import React from 'react';
import { Snackbar, Alert } from '@mui/material';

/**
 * Reusable Notification Component
 * @param {boolean} open - Whether the notification is visible
 * @param {function} onClose - Callback when notification closes
 * @param {string} message - Message to display
 * @param {string} severity - Type of notification: 'success', 'error', 'warning', 'info'
 */
const NotificationMessage = ({ open, onClose, message, severity = 'success' }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationMessage;
